import { HttpClient } from '@angular/common/http';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { DataTableUtilities } from '@app/core/utilities/data-table-utilities';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { BiosampleLibraryPrepSearchColumnFields, BiosampleLibraryPrepSearchGridOptionsFormatter } from '@app/search/gridOptions/biosample-library-prep-search-grid-options-formatter';
import { OverrideColumnDefinition, OverrideColumnParameters } from '@app/search/gridOptions/search-grid-options-formatter';

export class BiosampleLibraryPrepResourceMatcherGridOptionsFormatter extends BiosampleLibraryPrepSearchGridOptionsFormatter {
  constructor(
    public resourceDictionaryService: SearchResourceDictionaryService,
    public bsshDatePipe: BsshDatePipe,
    public http: HttpClient
  ) {
    super(resourceDictionaryService, bsshDatePipe, http);
  }

  protected getOverrideColumnParameters(): OverrideColumnParameters<BiosampleLibraryPrepSearchColumnFields> {
    const inclusiveColumns: BiosampleLibraryPrepSearchColumnFields[] = [
      BiosampleLibraryPrepSearchColumnFields.BioSampleName,
      BiosampleLibraryPrepSearchColumnFields.PrepKitName,
      BiosampleLibraryPrepSearchColumnFields.DefaultProjectName,
    ];

    const overrideColumnDefinitions: OverrideColumnDefinition<BiosampleLibraryPrepSearchColumnFields>[] = [
      {
        colId: BiosampleLibraryPrepSearchColumnFields.BioSampleName,
        cellRendererParams: (params) => {
          if (params.data && params.data.BioSampleLibraryPrep) {
            // Extract biosample ID from composite ID (format: "biosampleId::prepId")
            const biosampleId = params.data.BioSampleLibraryPrep.Id.split('::')[0];
            return DataTableUtilities.getRadLinkParams(
              params.data.BioSampleLibraryPrep.BioSampleName,
              `/biosamples/${biosampleId}`,
              null,
              null,
              70
            );
          } else {
            return {};
          }
        }
      }
    ];

    return {
      inclusiveColumns,
      overrideColumnDefinitions
    };
  }
}

